import React, { useState } from 'react';
import './sideDrawer.scss';
import ReactDom from 'react-dom';
import Close from '../../../assets/images/close.svg';
import { ReactComponent as EllipseIcon } from '../../../assets/icons/ellipse.svg';
import WorkingDetailsCard from '../workingDetailsCard/workingDetailsCard';
import WorkingHoursLabel from '../../../components/staff-registration/working-hours-label/working-hours-label';

interface IPortalModal {
    onClose(): any;
}

const PortalModal = ({ onClose }: IPortalModal) => {
    const [secondScreen, setSecondScreen] = useState<boolean>(false);
    const nameList = ['나매니저', '홍직원', '홍직원', '홍직원', '홍직원', '홍직원', '홍직원'];
    return ReactDom.createPortal(
        <>
            <div className="SideDrawerOverlayStyles">
                <div className="SideDrawerModalStyles">
                    <div
                        className="closeButton"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        <img src={Close} alt="" />
                    </div>
                    {!secondScreen ? (
                        <div className="drawerOne">
                            <div className="header">10월 24일</div>
                            <div className="headerRow">
                                <div className="leftContainer">🕒 근무시간</div>
                                <div className="rightContainer">
                                    <div className="hours">총 8시간</div>
                                </div>
                            </div>

                            <div className="timeRow">09 :00 ~ 18:00 (휴식 60분 포함)</div>
                            <div className="nameDataRow">🧑‍💻 직원</div>

                            <div className="description">근무일정이 궁금하면 직원 이름을 선택해보세요</div>

                            <div className="nameListWrapper">
                                {nameList.map((name) => (
                                    <div
                                        className="nameTab"
                                        onClick={() => {
                                            setSecondScreen(true);
                                        }}
                                    >
                                        {name}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="drawerTwo">
                            <div className="header">
                                <div className="image">길동</div>
                                <div className="name">홍길동</div>{' '}
                            </div>
                            <div className="personalInfo">
                                <div className="headingWithSettings">근무일정</div>

                                <div className="label">일하는 방식</div>
                                <div className="greenValue">선택적근무</div>
                                <br />
                                <div className="label">반복기간</div>
                                <div className="value">2022.12.01~</div>
                            </div>

                            <WorkingDetailsCard
                                weeks={'1, 2, 3, 4주'}
                                days={'월, 화, 수, 목, 금'}
                                time={'09:00 ~ 18:00'}
                                hours={'8시간'}
                                breakHours={'휴식 60분 포함'}
                            />

                            <WorkingDetailsCard
                                weeks={'1주'}
                                days={'토,일'}
                                time={'09:00 ~ 13:30'}
                                hours={'4.5시간'}
                                breakHours={'휴식 없음'}
                            />
                            <div className="dividerRow">
                                <div className="icon">
                                    <EllipseIcon />
                                </div>

                                <div className="labelText">일하는 방식</div>
                                <div className="line"></div>
                            </div>

                            <WorkingHoursLabel leftText="주  52시간" rightText="적합한 설정입니다" icon="tick" />

                            <div className="buttonRow">
                                <button
                                    onClick={() => {
                                        onClose();
                                    }}
                                    className="cancelButton"
                                >
                                    취소
                                </button>
                                <button
                                    onClick={() => {
                                        onClose();
                                    }}
                                    className="confirmButton"
                                >
                                    근무일정 수정
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>,
        document.getElementById('modalPortal')!,
    );
};

export default PortalModal;
